
















// @ is an alias to /src
import { Vue, Component } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import ResetPasswordComplete from "@/components/auth/resetPasswordComplete.vue";

@Component({
  name: "ResetPassword",
  components: {
    QErrors,
    ResetPasswordComplete,
  },
})
export default class ResetPasswordExpired extends Vue {
  public isShow = false;

  public redirectLogin() {
    this.$router.push({
      name: "admin.login",
    });
  }
}
